import { FormInstance } from "antd/es/form";
import _ from "lodash";
import React from "react";
import { IUserInfoDto } from "../../models/dto/user-info.dto";
import { IValidationData } from "../../models/dto/validation-data";
import { UserService } from "../../services/user-service";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IBakimForm_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IBakimForm_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  BakimKaydet: any;
  BakimKaydet_dummy: any;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  SetValueOf: any;
  SetValueOf_dummy: any;
  BakimGorunumAyarla: any;
  BakimGorunumAyarla_dummy: any;
  GetYetki: any;
  GetYetki_dummy: any;
  BakimNedeniSelectAll: any[];
  BakimNedeniSelectAll_dummy: any[];
  UcakListe: any[];
  UcakListe_dummy: any[];
  BakimciListe: any[];
  BakimciListe_dummy: any[];
  BakimGetir: any[];
  BakimGetir_dummy: any[];
  YazismaGetir: any[];
  YazismaGetir_dummy: any[];
  YazismaEkle: string;
  YazismaEkle_dummy: string;
  isComp162835Visible: "visible" | "hidden";
  isComp242250Visible: "visible" | "hidden";
  isComp506865Visible: "visible" | "hidden";
  isComp24225Visible: "visible" | "hidden";
  isComp949529Visible: "visible" | "hidden";
  isComp249814Visible: "visible" | "hidden";
  isComp385661Visible: "visible" | "hidden";
  isComp422516Visible: "visible" | "hidden";
  isComp15012Visible: "visible" | "hidden";
  isComp203119Visible: "visible" | "hidden";
  isComp848871Visible: "visible" | "hidden";
  isComp808818Visible: "visible" | "hidden";
  isComp354518Visible: "visible" | "hidden";
  isComp510322Enabled: "enabled" | "disabled";
  isComp341783Enabled: "enabled" | "disabled";
}

export class BakimForm_ScreenBase extends React.PureComponent<
  IBakimForm_ScreenProps,
  any
> {
  bakimform_24259_value_kuikaDatetimeRef: React.RefObject<any>;
  bakimform_348523_value_kuikaDatetimeRef: React.RefObject<any>;
  bakimform_412266_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "00d1d0d4-5c86-4a4d-8bbc-877f58a2737a",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 854746, PropertyName: "label", Value: "Vazgeç" },
        { Id: 162835, PropertyName: "label", Value: "Kaydet" },
        { Id: 242250, PropertyName: "label", Value: "İptal Et" },
        { Id: 972475, PropertyName: "value", Value: "Bakım Kaydı" },
        { Id: 506865, PropertyName: "placeholder", Value: "User Role Names" },
        { Id: 24225, PropertyName: "label", Value: "Yönetici Asistanı" },
        { Id: 949529, PropertyName: "label", Value: "Ucuş Müdürü" },
        { Id: 249814, PropertyName: "label", Value: "Pilot" },
        { Id: 385661, PropertyName: "label", Value: "Yolcu" },
        { Id: 422516, PropertyName: "label", Value: "Teknisyen" },
        { Id: 15012, PropertyName: "label", Value: "Tarihçe" },
        { Id: 860329, PropertyName: "value", Value: "Bakım Talep No" },
        {
          Id: 510322,
          PropertyName: "placeholder",
          Value: "Kaydedildikten sonra oluşacak...",
        },
        { Id: 7557, PropertyName: "value", Value: "Bakım Nedeni" },
        { Id: 978009, PropertyName: "placeholder", Value: "Choose..." },
        { Id: 497421, PropertyName: "value", Value: "Başlangıç Zamanı" },
        {
          Id: 24259,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 617128, PropertyName: "value", Value: "Bitiş Zamanı" },
        {
          Id: 348523,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 546698, PropertyName: "value", Value: "Karşılama No" },
        { Id: 699395, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 70519, PropertyName: "value", Value: "İptal Durumu" },
        { Id: 347625, PropertyName: "value", Value: "Bakım Sorumluları" },
        { Id: 297249, PropertyName: "placeholder", Value: "Choose..." },
        { Id: 308589, PropertyName: "value", Value: "Yazışma" },
        {
          Id: 412266,
          PropertyName: "nodatafoundmessage",
          Value: "Henüz yolcu yok...",
        },
        { Id: 777940, PropertyName: "title", Value: "Yazışma" },
        { Id: 296137, PropertyName: "value", Value: "[datafield:metin]" },
        { Id: 565085, PropertyName: "value", Value: "[datafield:talepeden]" },
        {
          Id: 987221,
          PropertyName: "value",
          Value: "[datafield:talepedenzaman]",
        },
        { Id: 54829, PropertyName: "value", Value: "[datafield:metin]" },
        {
          Id: 487355,
          PropertyName: "value",
          Value: "[datafield:onaylayanzaman]",
        },
        { Id: 132389, PropertyName: "value", Value: "[datafield:onaylayan]" },
        {
          Id: 755702,
          PropertyName: "placeholder",
          Value: "Bir mesaj yazın ...",
        },
        { Id: 631587, PropertyName: "label", Value: "Gönder" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.bakimform_506865_value_kuikaTextInputRef = React.createRef();
    this.bakimform_510322_value_kuikaTextInputRef = React.createRef();
    this.bakimform_24259_value_kuikaDatetimeRef = React.createRef();
    this.bakimform_348523_value_kuikaDatetimeRef = React.createRef();
    this.bakimform_699395_value_kuikaTextInputRef = React.createRef();
    this.bakimform_412266_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      BakimKaydet: "",
      IfThenElse: false,
      SetValueOf: "",
      TriggerEvent: "",
      BakimGorunumAyarla: "",
      GetYetki: "",
      BakimNedeniSelectAll: [],
      UcakListe: [],
      BakimciListe: [],
      BakimGetir: [],
      YazismaGetir: [],
      YazismaEkle: "",
      isComp162835Visible: "hidden",
      isComp242250Visible: "hidden",
      isComp506865Visible: "hidden",
      isComp24225Visible: "hidden",
      isComp949529Visible: "hidden",
      isComp249814Visible: "hidden",
      isComp385661Visible: "hidden",
      isComp422516Visible: "hidden",
      isComp15012Visible: "hidden",
      isComp203119Visible: "hidden",
      isComp848871Visible: "hidden",
      isComp808818Visible: "hidden",
      isComp354518Visible: "hidden",
      isComp510322Enabled: "disabled",
      isComp341783Enabled: "disabled",
    };

    this.CheckPageAuthorization(this.state);
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("bakimform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.BakimFormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("bakimform", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  CheckPageAuthorization = async (state) => {
    KuikaAppManager.showSpinner(this);
    if (_.isEmpty(window.userInfo)) {
      await UserService.GetUserInfoForce();
    }
    const permittedRoleNames: string[] = ["FLYPILOT", "FLYTEKNISYEN"];
    const userInfo = window.userInfo as IUserInfoDto;
    const userRoleNames = userInfo.roles.map((role) => role.name);
    if (
      !permittedRoleNames.some((roleName) => userRoleNames.includes(roleName))
    ) {
      await ReactSystemFunctions.goBack(this);

      const language = localStorage.getItem("ml");
      let permissonErrorMessageText =
        "You do not have permission to access this page.";
      if (language === "tr_TR") {
        permissonErrorMessageText = "Bu sayfaya erişim yetkiniz yok.";
      } else if (language === "fr_FR") {
        permissonErrorMessageText =
          "Vous n'avez pas la permission d'accéder à cette page.";
      } else if (language === "de_DE") {
        permissonErrorMessageText =
          "Sie haben keine Berechtigung, auf diese Seite zuzugreifen.";
      } else if (language === "es_ES") {
        permissonErrorMessageText =
          "No tienes permiso para acceder a esta página.";
      }

      KMainFunctions.displayErrorNotification(permissonErrorMessageText);
      state.isPageVisible = false;
      KuikaAppManager.hideSpinner(this);
      return;
    }
    state.isPageVisible = true;
    KuikaAppManager.hideSpinner(this);
  };

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("bakimform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.BakimFormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      bakimform_24225_checked: this.state.GetYetki?.asistan ?? undefined,
      bakimform_949529_checked: this.state.GetYetki?.mudur ?? undefined,
      bakimform_249814_checked: this.state.GetYetki?.pilot ?? undefined,
      bakimform_385661_checked: this.state.GetYetki?.yolcu ?? undefined,
      bakimform_422516_checked: this.state.GetYetki?.teknisyen ?? undefined,
      bakimform_341783_value: false,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  BakimFormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      BakimId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BakimId ?? this.props.screenInputs.bakimid,
        "Guid"
      ),
      CrudMode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakimForm/BakimFormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BakimGorunumAyarla = result?.data.bakimGorunumAyarla;
    stateVars.isComp162835Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.BakimGorunumAyarla?.degistir
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp242250Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, stateVars.BakimGorunumAyarla?.iptal),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakimFormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_506865_value",
        "string"
      ),
      ReactSystemFunctions.getMyRoleNames(),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BakimFormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      yetkiStr_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakimform_506865_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BakimId ?? this.props.screenInputs.bakimid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakimForm/BakimFormPageInit2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetYetki = result?.data.getYetki;
    formVars.bakimform_24225_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.asistan
    );
    formVars.bakimform_949529_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.mudur
    );
    formVars.bakimform_249814_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.pilot
    );
    formVars.bakimform_385661_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.yolcu
    );
    formVars.bakimform_422516_checked = ReactSystemFunctions.value(
      this,
      stateVars.GetYetki?.teknisyen
    );
    stateVars.BakimNedeniSelectAll = result?.data.bakimNedeniSelectAll;

    formVars.bakimform_978009_options = stateVars.BakimNedeniSelectAll;
    stateVars.UcakListe = result?.data.ucakListe;
    stateVars.BakimciListe = result?.data.bakimciListe;

    formVars.bakimform_297249_options = stateVars.BakimciListe;
    stateVars.BakimGetir = result?.data.bakimGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakimFormPageInit_if3 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_297249_value",
        "string"
      ),
      ReactSystemFunctions.getMyUsername(),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BakimFormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "0"
      )
    ) {
      isErrorOccurred = await this.BakimFormPageInit_if3();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit4_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BakimFormPageInit_if4 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_510322_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.BakimGetir !== undefined
          ? stateVars.BakimGetir?.length > 0
            ? stateVars.BakimGetir[0].bakimNo
            : null
          : this.state.BakimGetir?.length > 0
          ? this.state.BakimGetir[0].bakimNo
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_978009_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.BakimGetir !== undefined
          ? stateVars.BakimGetir?.length > 0
            ? stateVars.BakimGetir[0].bakimNedenleri
            : null
          : this.state.BakimGetir?.length > 0
          ? this.state.BakimGetir[0].bakimNedenleri
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit_if41_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BakimFormPageInit_if41_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_24259_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.BakimGetir !== undefined
          ? stateVars.BakimGetir?.length > 0
            ? stateVars.BakimGetir[0].baslangicZamani
            : null
          : this.state.BakimGetir?.length > 0
          ? this.state.BakimGetir[0].baslangicZamani
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit_if42_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BakimFormPageInit_if42_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_348523_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.BakimGetir !== undefined
          ? stateVars.BakimGetir?.length > 0
            ? stateVars.BakimGetir[0].bitisZamani
            : null
          : this.state.BakimGetir?.length > 0
          ? this.state.BakimGetir[0].bitisZamani
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit_if43_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BakimFormPageInit_if43_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_297249_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.BakimGetir !== undefined
          ? stateVars.BakimGetir?.length > 0
            ? stateVars.BakimGetir[0].bakimSorumlular
            : null
          : this.state.BakimGetir?.length > 0
          ? this.state.BakimGetir[0].bakimSorumlular
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit_if44_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BakimFormPageInit_if44_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_341783_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.BakimGetir !== undefined
          ? stateVars.BakimGetir?.length > 0
            ? stateVars.BakimGetir[0].isIptal
            : null
          : this.state.BakimGetir?.length > 0
          ? this.state.BakimGetir[0].isIptal
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit_if45_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BakimFormPageInit_if45_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_341783_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.BakimGetir !== undefined
          ? stateVars.BakimGetir?.length > 0
            ? stateVars.BakimGetir[0].isIptal
            : null
          : this.state.BakimGetir?.length > 0
          ? this.state.BakimGetir[0].isIptal
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_699395_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.BakimGetir !== undefined
          ? stateVars.BakimGetir?.length > 0
            ? stateVars.BakimGetir[0].karsilamaNo
            : null
          : this.state.BakimGetir?.length > 0
          ? this.state.BakimGetir[0].karsilamaNo
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BakimFormPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "2"
      ) ||
      ReactSystemFunctions.isEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        "1"
      )
    ) {
      isErrorOccurred = await this.BakimFormPageInit_if4();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit5_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  BakimFormPageInit5_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      RezervasyonId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BakimId ?? this.props.screenInputs.bakimid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakimForm/BakimFormPageInit5_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YazismaGetir = result?.data.yazismaGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormPageInit6_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakimFormPageInit6_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.isComp162835Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          this.state.BakimGorunumAyarla?.degistir
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp242250Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.BakimGorunumAyarla?.iptal),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    formVars.bakimform_24225_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.asistan
    );

    formVars.bakimform_949529_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.mudur
    );

    formVars.bakimform_249814_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.pilot
    );

    formVars.bakimform_385661_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.yolcu
    );

    formVars.bakimform_422516_checked = ReactSystemFunctions.value(
      this,
      this.state.GetYetki?.teknisyen
    );

    stateVars.isComp15012Visible =
      ReactSystemFunctions.isNotEqualTo(
        this.props.screenInputs.CrudMode ?? this.props.screenInputs.crudmode,
        ReactSystemFunctions.convertToTypeByName("0", "string")
      ) === true
        ? "visible"
        : "hidden";

    stateVars.dataSource_978009 =
      stateVars.BakimNedeniSelectAll ?? this.state.BakimNedeniSelectAll;
    stateVars.dataSource_978009 =
      stateVars.BakimNedeniSelectAll ?? this.state.BakimNedeniSelectAll;

    stateVars.dataSource_297249 =
      stateVars.BakimciListe ?? this.state.BakimciListe;
    stateVars.dataSource_297249 =
      stateVars.BakimciListe ?? this.state.BakimciListe;

    stateVars.dataSource_412266 =
      stateVars.YazismaGetir ?? this.state.YazismaGetir;
    stateVars.isComp203119Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "bakimform_412266_value", "isYolcu"),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp848871Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "bakimform_412266_value", "isYolcu"),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp808818Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "bakimform_412266_value", "isYolcu"),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";
    stateVars.isComp354518Visible =
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, "bakimform_412266_value", "isYolcu"),
        ReactSystemFunctions.convertToTypeByName("False", "string")
      ) === true
        ? "visible"
        : "hidden";

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  BakimFormComponent_854746_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BakimForm",
      "BakimListe",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakimFormComponent_162835_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      BakimId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BakimId ?? this.props.screenInputs.bakimid,
        "Guid"
      ),
      BakimNedenleri_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "bakimform_978009_value",
            "value",
            "BakimNedeniSelectAll",
            "ad",
            "ad"
          )
        ),
        "string"
      ),
      BakimSorumlular_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "bakimform_297249_value",
            "value",
            "BakimciListe",
            "adSoyad",
            "adSoyad"
          )
        ),
        "string"
      ),
      BaslangicZamani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakimform_24259_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      BitisZamani_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakimform_348523_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      IsIptal_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakimform_341783_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      KarsilamaNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakimform_699395_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Ucak_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.UcakListe !== undefined
            ? stateVars.UcakListe?.length > 0
              ? stateVars.UcakListe[0].ad
              : null
            : this.state.UcakListe?.length > 0
            ? this.state.UcakListe[0].ad
            : null
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakimForm/BakimFormComponent_162835_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.BakimKaydet = result?.data.bakimKaydet;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormComponent_162835_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakimFormComponent_162835_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.BakimKaydet?.durum),
        "2"
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Mesaj",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.toString(this, this.state.BakimKaydet?.mesaj),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Konu",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.convertToTypeByName("Hata", "string"),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "IconSuccess0Alert1Warnin2Info3",
        ReactSystemFunctions.convertToTypeByName(1, "number")
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.BakimFormComponent_162835_onClick2_,
        "BakimForm",
        "MesajKutusu",
        "",
        "9924ef5f-4b84-4200-b624-8d76348c7686",
        "166670",
        null,
        null,
        "true",
        "500px",
        "350px",
        false,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.BakimFormComponent_162835_onClick2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  BakimFormComponent_162835_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.BakimKaydet?.durum),
        "1"
      )
    ) {
      KuikaAppManager.prepareForNavigation();
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Mesaj",
        ReactSystemFunctions.convertToTypeByName(
          ReactSystemFunctions.toString(this, this.state.BakimKaydet?.mesaj),
          "string"
        )
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "Konu",
        ReactSystemFunctions.convertToTypeByName("Uyarı", "string")
      );
      KuikaAppManager.addToPageInputVariables(
        "MesajKutusu",
        "IconSuccess0Alert1Warnin2Info3",
        ReactSystemFunctions.convertToTypeByName(2, "number")
      );

      stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
        this,
        this.BakimFormComponent_162835_onClick3_,
        "BakimForm",
        "MesajKutusu",
        "",
        "9924ef5f-4b84-4200-b624-8d76348c7686",
        "909141",
        null,
        null,
        "true",
        "500px",
        "350px",
        false,
        false
      );

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.BakimFormComponent_162835_onClick3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  BakimFormComponent_162835_onClick_if3 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.BakimKaydet?.mesaj),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Konu",
      ReactSystemFunctions.convertToTypeByName("Bilgi", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "IconSuccess0Alert1Warnin2Info3",
      ReactSystemFunctions.convertToTypeByName(0, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      this.BakimFormComponent_162835_onClick_if31_,
      "BakimForm",
      "MesajKutusu",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "817067",
      null,
      null,
      "true",
      "500px",
      "350px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };
  BakimFormComponent_162835_onClick_if31_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (await this.BakimFormComponent_854746_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  BakimFormComponent_162835_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.state.BakimKaydet?.durum),
        "0"
      )
    ) {
      isErrorOccurred = await this.BakimFormComponent_162835_onClick_if3();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakimFormComponent_242250_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_341783_value",
        "string"
      ),
      true,
      null,
      false
    );
    if (await this.BakimFormComponent_162835_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakimFormComponent_899034_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BakimForm",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "352231",
      null,
      "left",
      "true",
      "380px",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakimFormComponent_15012_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterTablo",
      ReactSystemFunctions.convertToTypeByName("Fly.Bakim", "string")
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "MasterId",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BakimId ?? this.props.screenInputs.bakimid,
        "Guid"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Ekleyen",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.BakimGetir !== undefined
            ? stateVars.BakimGetir?.length > 0
              ? stateVars.BakimGetir[0].ekleyen
              : null
            : this.state.BakimGetir?.length > 0
            ? this.state.BakimGetir[0].ekleyen
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "Degistiren",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.BakimGetir !== undefined
            ? stateVars.BakimGetir?.length > 0
              ? stateVars.BakimGetir[0].degistiren
              : null
            : this.state.BakimGetir?.length > 0
            ? this.state.BakimGetir[0].degistiren
            : null
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "EklemeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.BakimGetir !== undefined
            ? stateVars.BakimGetir?.length > 0
              ? stateVars.BakimGetir[0].eklemeZamani
              : null
            : this.state.BakimGetir?.length > 0
            ? this.state.BakimGetir[0].eklemeZamani
            : null
        ),
        "Date"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "TarihceList",
      "DegistitirmeZamani",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.BakimGetir !== undefined
            ? stateVars.BakimGetir?.length > 0
              ? stateVars.BakimGetir[0].degistirmeZamani
              : null
            : this.state.BakimGetir?.length > 0
            ? this.state.BakimGetir[0].degistirmeZamani
            : null
        ),
        "Date"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BakimForm",
      "TarihceList",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "385262",
      null,
      "right",
      "False",
      "100vw",
      "100vh",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  BakimFormComponent_631587_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "bakimform_755702_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Mesaj giriniz...",
      formName: "bakimform_755702_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
      IslemRUMB_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("B", "string"),
        "string"
      ),
      RezervasyonId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BakimId ?? this.props.screenInputs.bakimid,
        "Guid"
      ),
      Metin_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "bakimform_755702_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakimForm/BakimFormComponent_631587_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YazismaEkle = result?.data.yazismaEkle;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.BakimFormComponent_631587_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakimFormComponent_631587_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Mesaj",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, this.state.YazismaEkle),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "Konu",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("HATA", "string"),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MesajKutusu",
      "IconSuccess0Alert1Warnin2Info3",
      ReactSystemFunctions.convertToTypeByName(1, "number")
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "BakimForm",
      "MesajKutusu",
      "",
      "9924ef5f-4b84-4200-b624-8d76348c7686",
      "78493",
      null,
      null,
      "true",
      "500px",
      "350px",
      false,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  BakimFormComponent_631587_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      RezervasyonId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.BakimId ?? this.props.screenInputs.bakimid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "BakimForm/BakimFormComponent_631587_onClick_else1",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YazismaGetir = result?.data.yazismaGetir;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.BakimFormComponent_631587_onClick_else11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  BakimFormComponent_631587_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "bakimform_755702_value",
        "string"
      ),
      "",
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  BakimFormComponent_631587_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(this, this.state.YazismaEkle),
        ""
      )
    ) {
      isErrorOccurred = await this.BakimFormComponent_631587_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.BakimFormComponent_631587_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [, 352231] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.BakimFormPageInit();
    }
    if (diId == 166670) {
      isErrorOccurred = await this.BakimFormComponent_162835_onClick2_();
      if (isErrorOccurred) return true;
    } else if (diId == 909141) {
      isErrorOccurred = await this.BakimFormComponent_162835_onClick3_();
      if (isErrorOccurred) return true;
    } else if (diId == 817067) {
      isErrorOccurred = await this.BakimFormComponent_162835_onClick_if31_();
      if (isErrorOccurred) return true;
    }
  }
}
